<div class="grid">
  <!-- Billing Runs list -->
  <div class="col-12 md:col-3">
    <share-section-card title="Billing Runs" icon="pi pi-calendar" shadow="shadow-1">
      <!-- Selected run summary -->
      <div *ngIf="selectedBillingRun" class="surface-100 border-round p-3 mb-3">
        <div class="flex justify-content-between mb-1">
          <span class="text-500 text-sm">Order Number</span>
          <span class="text-900 font-medium text-sm">45123</span>
        </div>
        <div class="flex justify-content-between mb-1">
          <span class="text-500 text-sm">Start Date</span>
          <span class="text-900 text-sm">{{ selectedBillingRun?.date_period_start }}</span>
        </div>
        <div class="flex justify-content-between">
          <span class="text-500 text-sm">End Date</span>
          <span class="text-900 text-sm">{{ selectedBillingRun?.date_period_end }}</span>
        </div>
      </div>

      <p-listbox
        [options]="billingRuns || []"
        [(ngModel)]="selectedBillingRun"
        (onChange)="onBillingRunChange($event)"
        optionLabel="name"
      >
        <ng-template let-billingRun pTemplate="item">
          <div class="flex align-items-center justify-content-between w-full py-1">
            <div>
              <div class="text-900 font-medium text-sm">{{ billingRun.name }}</div>
              <div class="text-500 text-xs">
                {{ billingRun.date_period_start }} to {{ billingRun.date_period_end }}
              </div>
            </div>
            <p-tag
              [value]="billingRun.run_status | uppercase"
              [severity]="
                billingRun.run_status === 'completed'
                  ? 'success'
                  : billingRun.run_status === 'failed'
                    ? 'danger'
                    : 'warning'
              "
            ></p-tag>
          </div>
        </ng-template>
      </p-listbox>

      <div class="flex gap-2 mt-3">
        <button
          pButton
          icon="pi pi-plus"
          label="New Billing Run"
          class="p-button-outlined p-button-sm flex-1"
          (click)="openNewBillingRunDialog()"
        ></button>
      </div>
    </share-section-card>
  </div>

  <!-- Billing Schedule table -->
  <div class="col-12 md:col-9">
    <share-section-card title="Billing Schedule" icon="pi pi-table">
      <p-table
        #billingScheduleTable
        [value]="(scheduleLineItems$ | async) || []"
        sortField="representative.name"
        sortMode="single"
        [scrollable]="true"
        scrollHeight="400px"
        rowGroupMode="subheader"
        groupRowsBy="billing_type"
        [style]="{ 'min-width': '60rem' }"
        [loading]="(scheduleLineItemsLoading$ | async) || false"
        styleClass="p-datatable-sm"
      >
        <ng-template pTemplate="header">
          <tr>
            <th *ngFor="let col of columns">{{ col.name }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="groupheader" let-item>
          <tr pRowGroupHeader>
            <td [attr.colspan]="getNumberOfColumns()" class="text-center">
              <span class="font-bold ml-2">{{ item.billing_type }}</span>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr>
            <td *ngFor="let col of columns" class="white-space-nowrap">{{ item[col.field] }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <div *ngIf="selectedBillingRun" class="flex flex-column align-items-end text-right">
            <span>Total (Excl): 1000.00</span>
            <span>Total (Incl): 1150.00</span>
          </div>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="getNumberOfColumns()" class="text-center p-4">
              <i class="pi pi-info-circle text-yellow-500 text-4xl mb-2"></i>
              <p class="font-bold">No billing schedule items</p>
              <p class="text-600">Please select a billing run to view the schedule.</p>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </share-section-card>
  </div>
</div>
